import React from 'react';
import { Order } from '@hero/schema';
import { OrderRouteWithMap } from '../../Route/OrderRouteWithMap';

export interface DestinationCellProps {
  order: Order;
  /** Custom render function - if provided, will be used instead of the default compact route */
  renderRoute?: (order: Order) => React.ReactNode;
}

/**
 * DestinationCell - Renders the route/destinations column as a compact
 * "Origin → Destination" chip. Clicking opens `OrderMapModal` so the
 * user can view and edit pickup / dropoff pins.
 */
export const DestinationCell: React.FC<DestinationCellProps> = ({ order, renderRoute }) => {
  if (renderRoute) {
    return <div className="flex w-full min-w-0 flex-col items-start">{renderRoute(order)}</div>;
  }

  return (
    <div className="flex w-full min-w-0 flex-col items-start">
      <OrderRouteWithMap order={order} vehicle={order.load?.vehicles?.[0]} />
    </div>
  );
};
